export default __webpack_public_path__ + "static/mwb-da3ab278b1dd4f2f19acf210c9d46815.jpg";